module.exports = {
    env: {
      ENVM: process.env.ENVM,
      BASE: '/'
    },
    confEnv: {
      baseURL:  process.env.NODE_ENV === 'development' ? '/gateway/usaservice' : 'https://admin-oommc-test.sany.com.cn/gateway/usaservice',
      baseURL2:  process.env.NODE_ENV === 'development' ? '/honda-pc' : 'http://wdpc.szlanyou.com',
      baseURL3:  process.env.NODE_ENV === 'development' ? '/api' : 'http://wdshop-be.szlanyou.com'
    },
    confWp:{
      publicPath:  process.env.NODE_ENV === 'development' ? '/' : '/', // 基本路径
      outputDir:  process.env.NODE_ENV === 'development' ? 'sanyiusa' : 'sanyiusa' // 输出文件目录
    },
    qiankuan: {
      subShop: {
        entry: '/shopapp/'  // process.env.NODE_ENV === 'development' ? 'http://localhost:5501' : '/shopapp/'
      }
    },
    proxy: {
      '/shopapp': {
        target: 'http://localhost:5501',
        changeOrigin: true,
        // pathRewrite: {
        //    '^/shopapp': ''
        // }
       },
        '/sanyiusa/honda-pc/data/business_report': {
          target: 'http://wdpc.szlanyou.com',
          changeOrigin: true,
          pathRewrite: {
             '^/sanyiusa/honda-pc/data/business_report': '/honda-pc/data/business_report'
          }
        },
        '/gateway': {
          target: 'http://10.0.110.202:32726',
          changeOrigin: true
        },
        '/honda-pc': {
         target: 'http://wdpc.szlanyou.com',
         changeOrigin: true,
         pathRewrite: {
          '^/sanyiusa/honda-pc': '/honda-pc'
          }
       },
        '/api': {
         target: 'http://wdshop-be.szlanyou.com', //"http://172.16.162.198:8085",
         ws: false,
         changeOrigin: true,
         pathRewrite: {
           '^/api': ''
         },
       }
     }
}